class BlocklistService {
    constructor() {
        this.baseUrl = '/api/blocklists';
        this.csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
    }

    async createBlocklist(data) {
        try {
            const response = await fetch(this.baseUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': this.csrfToken
                },
                body: JSON.stringify(data)
            });

            if (!response.ok) {
                const error = await response.json();
                throw new Error(error.message || 'Ошибка создания блоклиста');
            }

            return await response.json();
        } catch (error) {
            throw error;
        }
    }

    async deleteBlocklist(id) {
        try {
            const response = await fetch(`${this.baseUrl}/${id}`, {
                method: 'DELETE',
                headers: {
                    'X-CSRF-TOKEN': this.csrfToken
                }
            });

            if (!response.ok) {
                throw new Error('Ошибка удаления блоклиста');
            }

            return true;
        } catch (error) {
            throw error;
        }
    }

    validateBlocklistData(data) {
        const errors = [];

        if (!data.name || !data.name.trim()) {
            errors.push('Название обязательно для заполнения');
        }

        if (!data.domains_apps || data.domains_apps.length === 0) {
            errors.push('Необходимо указать хотя бы один домен или приложение');
        }

        // Проверка формата доменов/приложений
        if (data.domains_apps) {
            const invalidItems = data.domains_apps.filter(item => {
                // Простая валидация - не пустая строка и содержит хотя бы одну точку или слеш
                return !item.trim() || (!item.includes('.') && !item.includes('/'));
            });

            if (invalidItems.length > 0) {
                errors.push('Некоторые домены или приложения имеют неверный формат');
            }
        }

        return {
            isValid: errors.length === 0,
            errors
        };
    }

    parseDomainsApps(text) {
        return text
            .split('\n')
            .map(item => item.trim())
            .filter(item => item.length > 0);
    }
}

export default new BlocklistService();
